export default __webpack_public_path__ + "static/media/turret.e7f452cc.svg";